var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41797 3L7.41016 6H11V8H7.41016L4.41797 11H3L3.00012 9.57903L5.58203 7L3 4.42V3H4.41797Z",
    fill: "white"
  })));
};
export default __webpack_public_path__ + "static/media/tree-merge-icon.6c113017.svg";
export { SvgComponent as ReactComponent };